import React, { useEffect, useState } from 'react';
import styles from './callback-button.module.scss';
import cn from 'classnames';
import { emitEvent } from '../../event-emitter';
import { EVENT_CLICK_ADDITIONAL_BUTTON } from '../../constants';
import { isMobile } from 'react-device-detect';

interface CallbackButtonProps {
	onClick: (event: React.MouseEvent) => void
	value?: string
	additionalCallbackButton?: {
		link: string
		value: string 
	}
}

interface Slide {
	value: string,
	link: string
}

export default function CallbackButton({value='Записаться на прием', additionalCallbackButton, onClick}:CallbackButtonProps) {
	const [current, setCurrent] = useState(0);
	const [delay, setDelay] = useState(false);
	const [slider, updateSlider] = useState<Slide[]>([]);

	function clickAdditionalButton(item:Slide) {
		window.open(item.link); 
		emitEvent(EVENT_CLICK_ADDITIONAL_BUTTON);
	}

	useEffect(() => {
		if (additionalCallbackButton && isMobile) {
			updateSlider([{
				value: 'Записаться на прием',
				link: 'form'
			}, additionalCallbackButton]);
		}
	}, [additionalCallbackButton]);


	useEffect(() => {
		if (!additionalCallbackButton && isMobile) return;
		const next = (current + 1 < slider.length) ? current + 1 : 0;
		const id = setTimeout(() => {setCurrent(next); setDelay(true)}, delay ? 3500 : 700);
		return () => clearTimeout(id);
	}, [current, delay, slider, additionalCallbackButton]);

	return (<>
		{(additionalCallbackButton && isMobile) ?
			<div className={styles.carousel}>
				{slider.map((item, index) => {
					return <button
						className={cn(styles.carouselItem, {[styles.active]: current == index})}
						onClick={item.link == 'form' ? onClick : () => clickAdditionalButton(item)}
            type="button"
            key={item.value}
					>
						{item.value}
					</button>
				})}
			</div>
			:
			<button className={styles.default} type="button" onClick={onClick}>{value}</button>
		}
	</>);
}